import { AuthApiClient } from '@guiker/conversation-shared'
import { useAuthenticatedApiClient } from '@guiker/react-framework'

export const useConversationApiClient = useAuthenticatedApiClient(AuthApiClient)
